import {connect} from "react-redux";
import {resetMailing, submitProductEnquiry} from "../../../actions/mailing";
import {withTranslation} from "react-i18next";
import QuestionForm from "../../../components/productDetail/QuestionForm/QuestionForm";
import type {ApplicationState} from "../../../reducers";

function mapStateToProps(state: ApplicationState, ownProps) {
	return {
		contactData: state.mailing.contactData,
		sendSuccess: state.mailing.enquirySuccess,
		sendError: state.mailing.enquiryError,
		captchaInvalid: state.mailing.invalidCaptcha,
		rateLimited: state.mailing.rateLimited,
		privacyNoteLinkUrl: state.config.privacyPolicyLink,
		locationChoices: state.location.locationChoices,
		pickupLocation: state.location.pickupLocation,
		isShopEnabled: state.config.isShopEnabled,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		submitEnquiry: enquiry => {
			dispatch(submitProductEnquiry(enquiry));
		},
		resetMailing: () => dispatch(resetMailing())
	};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(QuestionForm));
